import React, { useContext } from 'react';
import { GameContext } from '../../core/context/game.context';
import './progressBar.style.scss';

export default function ProgressBar({ max, progress, updateTo }: { max: number; progress: number; updateTo?: number }) {
  const [progressState, setProgressState] = React.useState<number>(progress);
  const toRef = React.useRef<number>();
  const gameCtx = useContext(GameContext);

  React.useEffect(() => {
    window.clearTimeout(toRef.current);
    toRef.current = window.setTimeout(() => {
      setProgressState(progress);
    }, updateTo * 1000);
  }, [progress, updateTo]);

  return (
    <section className="ProgressBarComponent">
      <span className="startIcon"></span>
      <progress value={progressState} max={max} style={{ accentColor: gameCtx.getTheme().main[2] }} />
      <span className="finishIcon"></span>
    </section>
  );
}
